import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./GetInTouch.css";
import HeroSection from "../../components/heroSection/HeroSection";
import Footer from "../../components/footer/Footer";
import FrequentlyAsked from "../../components/frequentlyAsked/FrequentlyAsked";

const chatImage = "/images/chat.png";

const GetInTouch = () => {
  const navigate = useNavigate();
  const [openFaq, setOpenFaq] = useState(0);
  const [email, setEmail] = useState("");

  const handleNavClick = (page) => {
    navigate(page);
  };

  const handleLogin = () => {
    console.log("Login clicked");
    navigate("/login");
  };

  const handleGetStarted = () => {
    console.log("Get Started clicked");
    navigate("/signup");
  };

  return (
    <div className="get-in-touch">
      <HeroSection
        title="Get in Touch"
        description="Need assistance? Our support team is always available to answer your questions and resolve any issues you might encounter. Reach out to us through any of the methods below, and we'll get back to you as soon as possible."
        showDecorative={true}
        variant="contact"
        activeNav="help"
        onNavClick={handleNavClick}
        onLoginClick={handleLogin}
        onGetStartedClick={handleGetStarted}
      />

      <section className="get-in-touch-chat-section">
        <div className="get-in-touch-chat-container">
          <div className="get-in-touch-chat-mockup">
            <img
              src={chatImage}
              alt="Chat Interface"
              className="get-in-touch-chat-image"
            />
          </div>
          <div className="get-in-touch-chat-content">
            <h2>Chat with us directly</h2>
            <p>
              "Need help fast? Chat with our support team on WhatsApp for
              instant assistance."
            </p>
            <a
              href="https://wa.me/2349119994186"
              target="_blank"
              rel="noopener noreferrer"
              className="get-in-touch-chat-support-btn"
              style={{ textDecoration: "none" }}
            >
              <svg
                className="get-in-touch-whatsapp-icon"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
              </svg>
              Chat Support
            </a>
          </div>
        </div>
      </section>

      <section className="get-in-touch-contact-methods">
        <h2 className="get-in-touch-section-title">
          You can also Reach out to us via email and phone call
        </h2>
        <div className="get-in-touch-contact-grid">
          <div className="get-in-touch-contact-card">
            <h3>Email Us</h3>
            <p>
              Can't find the answer you're looking for? Send us an email, and
              we'll get back to you promptly! We strive to respond to all
              inquiries within 24 hours. Please include as much detail as
              possible about your query, and we'll do our best to assist you.
            </p>
            <a
              href="mailto:nimblebashsupport@nimblebash.com"
              className="get-in-touch-contact-info"
              style={{ textDecoration: "none" }}
            >
              <svg
                className="get-in-touch-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <rect
                  x="3"
                  y="5"
                  width="18"
                  height="14"
                  rx="2"
                  strokeWidth="2"
                />
                <path d="M3 7l9 6 9-6" strokeWidth="2" />
              </svg>
              <span>nimblebashsupport@nimblebash.com</span>
            </a>
          </div>
          <div className="get-in-touch-contact-card">
            <h3>Call Us</h3>
            <p>
              Need immediate assistance? Our dedicated support team is here to
              help! Call us with the number below:
            </p>
            <a
              href="https://wa.me/2349919994186"
              target="_blank"
              rel="noopener noreferrer"
              className="get-in-touch-contact-info"
              style={{ textDecoration: "none" }}
            >
              <svg
                className="get-in-touch-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path
                  d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"
                  strokeWidth="2"
                />
              </svg>
              <span>+2349919994186</span>
            </a>
          </div>
        </div>
      </section>

      <FrequentlyAsked />

      <Footer />
    </div>
  );
};

export default GetInTouch;